module.exports = __webpack_public_path__ + "img/walmart_logo.f5527677.png";